/** U11 (lote 1): várias caixas de e-mail (selo e filtro por caixa, uso de disco, retenção e anexo no provedor), nos três idiomas. */
const pt = {
  u11: {
    todasCaixas: 'Todas as caixas',
    filtroCaixa: 'Caixa de e-mail',
    noServidor: '{{tamanho}} no servidor',
    noProvedor: '{{tamanho}} no provedor',
    usoTitulo_one: '{{count}} mensagem, calculado {{quando}}',
    usoTitulo_other: '{{count}} mensagens, calculado {{quando}}',
    semUso: 'uso ainda não calculado',
    guardaTudo: 'guarda tudo',
    retencaoMeses_one: 'corpo por {{count}} mês',
    retencaoMeses_other: 'corpo por {{count}} meses',
    retencao: 'Retenção',
    retencaoTitulo: 'Retenção das caixas de e-mail',
    retencaoTexto:
      'Depois do prazo, o texto, o HTML e os anexos guardados no servidor saem das mensagens daquela caixa. Ficam o cabeçalho (de, para, assunto e data) e o link para abrir o e-mail no provedor, onde nada muda. Anexos acima de 1 MB já ficam no provedor e continuam baixáveis.',
    opcaoGuardaTudo: 'Guardar tudo',
    opcaoMeses_one: '{{count}} mês',
    opcaoMeses_other: '{{count}} meses',
    retencaoSalva: 'Retenção salva',
    noProvedorAnexo: 'Fica no provedor e é baixado ao abrir',
    baixarDoProvedor: 'Baixar {{nome}} do provedor',
    baixando: 'Baixando do provedor',
    anexoRemovido: 'Removido pela retenção',
    corpoRemovido_one: 'O corpo deste e-mail saiu pela retenção de {{count}} mês da caixa.',
    corpoRemovido_other: 'O corpo deste e-mail saiu pela retenção de {{count}} meses da caixa.',
    abrirNoGmail: 'Abrir no Gmail',
  },
};

type Dic = typeof pt;

const en: Dic = {
  u11: {
    todasCaixas: 'All mailboxes',
    filtroCaixa: 'Email mailbox',
    noServidor: '{{tamanho}} on the server',
    noProvedor: '{{tamanho}} at the provider',
    usoTitulo_one: '{{count}} message, measured {{quando}}',
    usoTitulo_other: '{{count}} messages, measured {{quando}}',
    semUso: 'usage not measured yet',
    guardaTudo: 'keeps everything',
    retencaoMeses_one: 'body for {{count}} month',
    retencaoMeses_other: 'body for {{count}} months',
    retencao: 'Retention',
    retencaoTitulo: 'Email mailbox retention',
    retencaoTexto:
      'After the period, the text, the HTML and the attachments stored on the server leave the messages of that mailbox. The header (from, to, subject and date) and the link to open the email at the provider stay, and nothing changes there. Attachments over 1 MB already stay at the provider and can still be downloaded.',
    opcaoGuardaTudo: 'Keep everything',
    opcaoMeses_one: '{{count}} month',
    opcaoMeses_other: '{{count}} months',
    retencaoSalva: 'Retention saved',
    noProvedorAnexo: 'Stays at the provider and is downloaded when opened',
    baixarDoProvedor: 'Download {{nome}} from the provider',
    baixando: 'Downloading from the provider',
    anexoRemovido: 'Removed by retention',
    corpoRemovido_one: "This email's body was removed by the mailbox's {{count}} month retention.",
    corpoRemovido_other: "This email's body was removed by the mailbox's {{count}} month retention.",
    abrirNoGmail: 'Open in Gmail',
  },
};

const es: Dic = {
  u11: {
    todasCaixas: 'Todos los buzones',
    filtroCaixa: 'Buzón de correo',
    noServidor: '{{tamanho}} en el servidor',
    noProvedor: '{{tamanho}} en el proveedor',
    usoTitulo_one: '{{count}} mensaje, calculado {{quando}}',
    usoTitulo_other: '{{count}} mensajes, calculado {{quando}}',
    semUso: 'uso aún no calculado',
    guardaTudo: 'guarda todo',
    retencaoMeses_one: 'cuerpo por {{count}} mes',
    retencaoMeses_other: 'cuerpo por {{count}} meses',
    retencao: 'Retención',
    retencaoTitulo: 'Retención de los buzones de correo',
    retencaoTexto:
      'Después del plazo, el texto, el HTML y los adjuntos guardados en el servidor salen de los mensajes de ese buzón. Quedan el encabezado (de, para, asunto y fecha) y el enlace para abrir el correo en el proveedor, donde nada cambia. Los adjuntos de más de 1 MB ya quedan en el proveedor y se siguen pudiendo descargar.',
    opcaoGuardaTudo: 'Guardar todo',
    opcaoMeses_one: '{{count}} mes',
    opcaoMeses_other: '{{count}} meses',
    retencaoSalva: 'Retención guardada',
    noProvedorAnexo: 'Queda en el proveedor y se descarga al abrir',
    baixarDoProvedor: 'Descargar {{nome}} del proveedor',
    baixando: 'Descargando del proveedor',
    anexoRemovido: 'Eliminado por la retención',
    corpoRemovido_one: 'El cuerpo de este correo salió por la retención de {{count}} mes del buzón.',
    corpoRemovido_other: 'El cuerpo de este correo salió por la retención de {{count}} meses del buzón.',
    abrirNoGmail: 'Abrir en Gmail',
  },
};

export const u11 = { pt, en, es };
